import { render } from "./ListShimmer.vue?vue&type=template&id=b3b5a6f0&scoped=true"
import script from "./ListShimmer.vue?vue&type=script&lang=js"
export * from "./ListShimmer.vue?vue&type=script&lang=js"

import "./ListShimmer.vue?vue&type=style&index=0&id=b3b5a6f0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3b5a6f0"]])

export default __exports__